import { Label as LabelR, Row } from 'reactstrap';
import { Typography as TypographyMui } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const Label = styled(LabelR)`
  margin-left: -1rem;
  font-size: 1rem;
  color: #000;
`;

export const Typography = styled(TypographyMui)`
  color: #000;
  text-align: center;
`;

export const CondicaoPagamentoRecursoRow = styled(Row)`
  border-bottom: 1px solid #000;
  padding-top: 6px;
`;
